export const SPOTDIFF_API_REDUCER_KEY = 'spotdif' as const;
export const CHAT_API_REDUCER_KEY = 'spotdifChat' as const;
